import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_coupon_attachment_RowClass} from '../../../dbschema';

export class CouponAttachmentContainerModel extends BaseContainerModel {
  bl_fi_mst_coupon_attachment: bl_fi_mst_coupon_attachment_RowClass = new bl_fi_mst_coupon_attachment_RowClass();
}
